module.exports = __webpack_public_path__ + "img/88.dcabc4b4.jpg";